import React from 'react'
import Viewer from '../Viewer'

export class TextRender extends React.Component {
    render () {
        const { step } = this.props
        const { standardType } = this.props
        return (
            <Viewer objects={JSON.parse(step.content)} standardType={standardType}/>
        )
    }
}